import { Stack } from '@mui/material'
import { Footer, LoadingSkeleton, PageGridContainer, PageGridItem, tokens } from 'ComponentLibrary'
import { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { ValuationPageNavButtonsLoad } from 'ClientPortal/src/pages/Assets/AssetDetails/Valuation/ValuationLayout/ValuationPageNavButtons.load'

export default function ValuationPageLayoutLoading({ breadcrumbs }: { breadcrumbs: ReactNode }) {
    return (
        <Stack direction="column" minHeight="100%" bgcolor={tokens.ColorBackgroundDark}>
            <Stack direction="column" gap={tokens.SizingSpacing300}>
                <PageGridContainer background={`linear-gradient(${tokens.ColorBackgroundLight} 235.5px, transparent 235.5px)`}>
                    <PageGridItem columnSpan={6} columnSpanXs={4}>
                        <Stack direction="column" gap={tokens.SizingSpacing400}>
                            <Stack
                                direction="row"
                                paddingTop={tokens.SizingSpacing200}
                                paddingBottom={tokens.SizingSpacing300}
                                gap={tokens.SizingSpacing300}
                                width="100%"
                                alignItems="flex-end"
                            >
                                <Stack direction="column" flexGrow={1} gap={tokens.SizingSpacing300}>
                                    {breadcrumbs}
                                    <Stack direction="row" gap={tokens.SizingSpacing400} alignItems="flex-end">
                                        <Stack direction="column" gap={tokens.SizingSpacing200}>
                                            <Stack direction="column" gap={tokens.SizingSpacing075}>
                                                <LoadingSkeleton variant="rounded" height="24px" width="102px" />

                                                <LoadingSkeleton variant="rounded" height="34px" width="340px" />

                                                <LoadingSkeleton variant="rounded" height="34px" width="300px" />
                                            </Stack>
                                            <LoadingSkeleton variant="rounded" height="32px" width="430px" />
                                        </Stack>
                                        <Stack
                                            direction="column"
                                            alignItems="flex-end"
                                            flexGrow={1}
                                            minHeight="100%"
                                            gap={tokens.SizingSpacing400}
                                        >
                                            <Stack direction="row" gap={tokens.SizingSpacing150} alignItems="center">
                                                <LoadingSkeleton variant="rounded" height="32px" width="77px" />
                                                <LoadingSkeleton variant="rounded" height="32px" width="134px" />
                                                <LoadingSkeleton variant="rounded" height="32px" width="114px" />
                                            </Stack>
                                            <ValuationPageNavButtonsLoad flexGrow={1} />
                                        </Stack>
                                    </Stack>
                                </Stack>
                                <div style={{ backgroundColor: tokens.ColorBackgroundDark }}>
                                    <LoadingSkeleton variant="rounded" width="255px" height="170px" />
                                </div>
                            </Stack>

                            <LoadingSkeleton variant="rounded" height="40px" width="100%" />
                        </Stack>
                    </PageGridItem>
                </PageGridContainer>
                <Outlet />
            </Stack>

            <Footer withTopSpace />
        </Stack>
    )
}
